import { getCalculationDetailsData } from '@hex/calculators-shared/components/CalculationDetails/calculationDetailsData';
import { ErrorMessage } from '@hex/calculators-shared/components/ErrorMessage';
import { LoadingOverlay } from '@hex/calculators-shared/components/LoadingOverlay';
import { MonthlyLoanCostCard } from '@hex/calculators-shared/components/MonthlyLoanCostCard/MonthlyLoanCostCard';
import { amortizationRulesData } from '@hex/calculators-shared/components/MoreInformation/amortizationRulesData';
import { loanInsuranceData } from '@hex/calculators-shared/components/MoreInformation/LoanInsuranceData';
import { MoreInformation } from '@hex/calculators-shared/components/MoreInformation/MoreInformation';
import { nextStepsBuyingPropertyData } from '@hex/calculators-shared/components/MoreInformation/nextStepsBuyingPropertyData';
import { featureFlags } from '@hex/calculators-shared/constants';
import { ReferenceInterestRateResponse } from '@hex/calculators-shared/types';
import { useState } from 'react';
import { CostResponse, FormDataType } from '../../types';
import { parseFormData } from './utils';

type Props = {
  responseData: CostResponse | ReferenceInterestRateResponse | null;
  hasError: boolean;
  isLoading: boolean;
  formData?: FormDataType;
};

export function Results({ responseData, hasError, isLoading, formData }: Props) {
  const { ltv, loanAmount, secondaryApplicantExist } = parseFormData(formData);
  const rates = featureFlags.use3MonthInterestRate ? responseData : responseData?.interestRates;
  const disabled = !rates;
  const [currentInterestRate, setCurrentInterestRate] = useState<number>();

  if (hasError) {
    return <ErrorMessage />;
  }

  const moreInformationItems = [amortizationRulesData, loanInsuranceData, nextStepsBuyingPropertyData];
  const exampleInterestRate =
    rates && typeof rates === 'object' && 'exampleInterestRate' in rates ? rates.exampleInterestRate : undefined;

  const calculationDetailsInterestRate = featureFlags.use3MonthInterestRate
    ? (currentInterestRate ?? exampleInterestRate)
    : exampleInterestRate;

  if (
    ltv != null &&
    Number.isFinite(ltv) &&
    loanAmount != null &&
    Number.isFinite(loanAmount) &&
    exampleInterestRate != null
  ) {
    moreInformationItems.unshift(
      getCalculationDetailsData({
        loanAmount,
        ltv,
        exampleInterestRate: calculationDetailsInterestRate,
        interestRate: currentInterestRate ?? exampleInterestRate,
        secondaryApplicantExist: secondaryApplicantExist ?? false,
      }),
    );
  }

  return (
    <LoadingOverlay isLoading={isLoading}>
      <MonthlyLoanCostCard
        rates={rates}
        ltv={ltv}
        loanAmount={loanAmount}
        secondaryApplicantExist={secondaryApplicantExist}
        displayNavigateLoanApplicationButton
        dataTrackingId={'lead:housing:cost-calculator'}
        onInterestRateChange={setCurrentInterestRate}
      />
      {!disabled && <MoreInformation items={moreInformationItems} />}
    </LoadingOverlay>
  );
}
